import { useTranslation } from 'react-i18next';

import {
  Button,
  ButtonsWrapper,
  CheckboxSelect,
  Form,
  Modal,
} from '@thinknet-gmbh/platform-common-ui';

import { useGetTaskTemplatesByCompany } from 'src/hooks/task-templates/get-task-templates-by-company.hook';
import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';

export const TaskTemplatesModal = ({
  onClose,
  onFinish,
}: {
  onClose: () => void;
  onFinish: (values: any) => void;
}) => {
  const { t } = useTranslation(['common', 'projects']);

  const currentCompanyId = useGetCurrentCompanyId();
  const { taskTemplates } = useGetTaskTemplatesByCompany(currentCompanyId);

  return (
    <Modal isOpened onClose={onClose} title={t('projects:')}>
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="taskTemplatesIds"
          label={t('projects:labels.templatesName')}
          rules={[{ required: true }]}
        >
          <CheckboxSelect
            showSearch
            placeholder={t('common:placeholders.selectFromList')}
            optionData={taskTemplates.map((template: any) => ({
              value: template._id,
              label: template.templateName,
            }))}
          />
        </Form.Item>

        <ButtonsWrapper>
          <Button htmlType="submit" type="primary">
            {t('common:buttons.save')}
          </Button>
          <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </Modal>
  );
};
